import {useEffect, useState} from 'react';

import {createInitialDashboardState} from './dashboardMockData';
import {DashboardState} from './dashboardModel';

const TICK_MS = 1000;

export function useDashboard() {
  const [state, setState] = useState<DashboardState>(() => createInitialDashboardState());

  useEffect(() => {
    const interval = window.setInterval(() => {
      setState((prev) => ({...prev, now: Date.now()}));
    }, TICK_MS);

    return () => window.clearInterval(interval);
  }, []);

  return {state};
}
